<template>
    <svg aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15 15L10.8883 10.6627M10.8883 10.6627C11.8592 9.6365 12.4545 8.25141 12.4545 6.72727C12.4545 3.56419 9.89036 1 6.72727 1C3.56419 1 1 3.56419 1 6.72727C1 9.89036 3.56419 12.4545 6.72727 12.4545C8.36622 12.4545 9.84438 11.7661 10.8883 10.6627Z"
            stroke="black"
            stroke-linecap="round" />
    </svg>
</template>
